
  import { Component, Vue, Prop } from "vue-property-decorator";
  import RingSizeInstructions from "./RingSizeInstructions.vue";
  import RingSizeParams from "./RingSizeParams.vue";

  @Component({
    components: { 
        RingSizeInstructions,
        RingSizeParams
    },
  })
  export default class ProductSelectSizeModal extends Vue {
    // @ts-ignore
    @Prop({ required: true, default: false }) public readonly modalShow: boolean;
    // @ts-ignore
   
    public isModalClosed: boolean = false;
    // public isShowModalByTariffFromDexNetToken: boolean = false
  
    // Methods
    public closeModal() {
      this.isModalClosed = true;
      this.$emit("close-modal");
    }
  }
  